module.exports = __webpack_public_path__ + "static/mnews03.png";